import React from "react";
import "./success-form.styles.scss";
const SuccessForm = () => (
  <div className="main-content">
    <h1>Success. Thank you for submitting a lead</h1>
  </div>
);

export default SuccessForm;
